<template>
  <b-row align-v="center" class="px-4 py-2">
    <!-- <b-col md="auto" class="px-0 ml-3">
      <img
        alt="user"
        class="w-12 h-12 avatar rounded-full object-cover"
        :src="userImage"
        v-if="userImage"
      />
      <b-avatar variant="info" class="p-3 cust-avatar" v-else></b-avatar>
    </b-col> -->
    <img
      alt="user"
      class="rounded-full w-8 h-8"
      :src="userImage"
      v-if="userImage"
    />
    <b-avatar
      variant="info "
      class="p-2 text-xl cust-avatar"
      size="lg"
      v-else
    ></b-avatar>
    <!-- <b-avatar variant="info" class="p-3 cust-avatar"></b-avatar> -->
    <b-col class="pl-0 pr-0 ml-1">
      <div class="d-flex justify-content-between align-items-center">
        <div class="ml-2">
          <h4 class="mb-0 text-sm font-semibold">{{ name }}</h4>
        </div>

        <div class="flex">
          <div>
            <!-- <b-button v-if="isYou" type="button" outline size="sm"
              >You</b-button
            > -->
            <b-badge
              pill
              variant="info"
              v-if="isAdmin"
              type="button"
              outline
              :class="{
                'bg-kotakblue': isAdmin,
                'text-white': isAdmin,
              }"
              size="sm"
              class="pils-chips-ui"
              >{{ role }}</b-badge
            >
            <!-- <b-button
              v-if="isAdmin"
              type="button"
              outline
              :class="{
                'bg-kotakblue': isAdmin,
                'text-white': isAdmin
              }"
              size="sm"
              >{{ role }}</b-button
            > -->
          </div>
          <ChannelMemberOptions
            :isAdmin="isAdmin"
            :isOwner="isOwner"
            :userID="member._user.id"
            :currentUserRole="currentUserRole"
            v-if="!isYou && isCurrentUserAdmin"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";

import ChannelMemberOptions from "./ChannelMemberOptions";

export default {
  props: {
    member: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ChannelMemberOptions,
  },
  data() {
    return {
      adminRoles: ["owner", "admin"],
    };
  },
  computed: {
    ...mapState("auth", {
      user: "user",
    }),
    ...mapState("channel", {
      channel: "selectedChannel",
    }),
    isYou() {
      return this.member._user.id === this.user._id;
    },
    name() {
      if (this.member._user != null) {
        return `${this.member._user.firstname} ${this.member._user.lastname}`;
      }
    },
    userImage() {
      if (
        this.member._user.hasOwnProperty("userImage") &&
        this.member._user.userImage !== "null"
      ) {
        return (
          this.member._user.userImage &&
          `${this.$imageURL}/${this.member._user.userImage}`
        );
      } else {
        return false;
      }
    },
    isAdmin() {
      return this.adminRoles.includes(this.member.role);
    },
    isOwner() {
      return this.member.role === "owner";
    },
    role() {
      return (
        this.member.role[0].toUpperCase() +
        this.member.role.slice(1, this.member.role.length)
      );
    },
    currentUserRole() {
      return (
        this.channel &&
        this.channel.currentUser &&
        this.channel.currentUser.length &&
        this.channel.currentUser[0].role
      );
    },
    isCurrentUserOwner() {
      return this.currentUserRole === "owner";
    },
    isCurrentUserAdmin() {
      return ["owner", "admin"].includes(this.currentUserRole);
    },
  },
};
</script>
